<template>
	<div class="relative pt-32 pb-32 flex content-center items-center justify-center"
	     style="min-height: 55vh">
		<div class="absolute top-0 w-full h-full bg-center bg-cover"
		     :style="{ backgroundImage: image }">
			<span id="blackOverlay" class="w-full h-full absolute opacity-60 bg-black"/>
		</div>
		<div class="container relative mx-auto">
			<div class="items-center flex flex-wrap">
				<div class="w-full lg:w-8/12 px-4 ml-auto mr-auto text-center">
					<h1 class="text-white font-semibold text-5xl pb-4">
						{{ title }}
					</h1>
					<slot></slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "banner",
		props: {
			title: {
				type: String,
				required: true,
			},
			image: {
				type: String,
				required: false,
				default: 'url(/images/lnb/lnb-1.jpg)',
			},
		}
	}
</script>

<style scoped>

</style>